import React, { useState } from 'react';
import axios from 'axios';
import '../styles/Contact.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [responseMessage, setResponseMessage] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    setResponseMessage('');

    try {
      const response = await axios.post(`${API_URL}/api/contact`, formData);
      setStatus('success');
      setResponseMessage(response.data.message || 'Mensagem enviada com sucesso!');
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      });
    } catch (error: any) {
      setStatus('error');
      setResponseMessage(error.response?.data?.message || 'Erro ao enviar mensagem. Tente novamente.');
      console.error('Erro ao enviar contato:', error);
    }
  };

  return (
    <div className="contact-page">
      <section className="hero-contact">
        <div className="container">
          <h1>Entre em Contato</h1>
          <p>Estamos prontos para ouvir você e tirar suas dúvidas.</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info-card">
              <h2>Informações de Contato</h2>
              <div className="info-item">
                <i className="fas fa-map-marker-alt"></i>
                <div>
                  <h3>Endereço</h3>
                  <p>R. José Bezerra, 2033 - Nova Brasília, Ji-Paraná - RO, 76908-466</p>
                </div>
              </div>
              <div className="info-item">
                <i className="fas fa-phone"></i>
                <div>
                  <h3>Telefone</h3>
                  <p>(69) 99224-6189</p>
                  <p>(69) 99404-6340</p>
                </div>
              </div>
              <div className="info-item">
                <i className="fas fa-envelope"></i>
                <div>
                  <h3>Email</h3>
                  <p>contato@clinicacis.com.br</p>
                </div>
              </div>
              <div className="info-item">
                <i className="fas fa-clock"></i>
                <div>
                  <h3>Horário de Funcionamento</h3>
                  <p>Segunda a Sexta: 7h às 20h</p>
                  <p>Sábado: 7h às 12h</p>
                </div>
              </div>
              <div className="social-media-contact">
                <h3>Siga-nos</h3>
                <a href="https://www.instagram.com/fisiopilates.jipa" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                <a href="https://www.facebook.com/fisioterapiaepilates1" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
              </div>
            </div>

            <div className="contact-form-card">
              <h2>Envie uma Mensagem</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Nome Completo</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Telefone (WhatsApp)</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Assunto</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Sua Mensagem</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <button type="submit" className="btn btn-primary btn-lg" disabled={status === 'loading'}>
                  {status === 'loading' ? 'Enviando...' : 'Enviar Mensagem'}
                </button>
                {responseMessage && (
                  <p className={`response-message ${status}`}>{responseMessage}</p>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <h2 className="text-center">Onde Estamos</h2>
          <div className="map-container">
            <iframe
              src="https://maps.google.com/maps?q=-10.881,-61.948&z=16&output=embed"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen={true}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização da Clínica CIS - Ji-Paraná RO"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;

